import InputCurrencyBox from "./InputCurrencyBox";

export default InputCurrencyBox;